import { NavLink, Outlet, Link } from 'react-router-dom';
import { LayoutDashboard, Trophy, FolderTree, Brain, Users, Sparkles, ArrowLeft, Receipt, Network, ClipboardList, Handshake } from 'lucide-react';

const LINKS = [
  { to: '/admin', end: true, icon: LayoutDashboard, label: 'Dashboard' },
  { to: '/admin/concorsi', icon: Trophy, label: 'Concorsi' },
  { to: '/admin/adm-revisione', icon: ClipboardList, label: 'Revisione ADM' },
  { to: '/admin/inps499-importazione', icon: ClipboardList, label: 'Revisione INPS 499' },
  { to: '/admin/contenuti', icon: FolderTree, label: 'Contenuti' },
  { to: '/admin/learning-graph', icon: Network, label: 'Learning Graph' },
  { to: '/admin/pipeline', icon: Sparkles, label: 'Pipeline AI' },
  { to: '/admin/coverage-planner', icon: ClipboardList, label: 'Coverage Planner' },
  { to: '/admin/quiz', icon: Brain, label: 'Quiz' },
  { to: '/admin/utenti', icon: Users, label: 'Utenti e ordini' },
  { to: '/admin/vendite', icon: Receipt, label: 'Vendite e fiscalità' },
  { to: '/admin/affiliati', icon: Handshake, label: 'Affiliati' },
  { to: '/admin/bando', icon: Sparkles, label: 'Analisi legacy' },
];

export default function AdminLayout() {
  return (
    <div className="page-shell py-8" data-testid="admin-layout">
      <div className="flex items-center justify-between mb-6">
        <div><p className="eyebrow mb-1">Workspace operativo</p><h1 className="font-display text-2xl sm:text-3xl tracking-tight font-bold text-brand-dark" data-testid="admin-title">Amministrazione</h1></div>
        <Link to="/" className="text-xs font-semibold text-slate-500 hover:text-brand inline-flex items-center gap-1" data-testid="admin-back-site">
          <ArrowLeft size={13} strokeWidth={1.5} /> Torna al sito
        </Link>
      </div>
      <div className="flex flex-col md:flex-row gap-8">
        <aside className="hidden md:block w-52 shrink-0">
          <nav className="surface space-y-1 sticky top-24 p-2">
            {LINKS.map((l) => (
              <NavLink key={l.to} to={l.to} end={l.end} data-testid={`admin-nav-${l.label.toLowerCase().replace(/\s/g, '-')}`}
                className={({ isActive }) => `flex items-center gap-2.5 rounded-xl px-3.5 py-2.5 text-sm font-medium transition-colors ${isActive ? 'bg-brand text-white' : 'text-slate-600 hover:bg-slate-100'}`}>
                <l.icon size={16} strokeWidth={1.5} /> {l.label}
              </NavLink>
            ))}
          </nav>
        </aside>
        <div className="md:hidden w-full mb-4 overflow-x-auto">
          <nav className="flex gap-2 pb-2">
            {LINKS.map((l) => (
              <NavLink key={l.to} to={l.to} end={l.end}
                className={({ isActive }) => `flex items-center gap-1.5 rounded-full px-3.5 py-2 text-xs font-medium whitespace-nowrap ${isActive ? 'bg-brand text-white' : 'bg-white border border-slate-200 text-slate-600'}`}>
                <l.icon size={13} strokeWidth={1.5} /> {l.label}
              </NavLink>
            ))}
          </nav>
        </div>
        <main className="flex-1 min-w-0">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
